import { render, staticRenderFns } from "./PaginationTooltip.vue?vue&type=template&id=c0fc67b8"
import script from "./PaginationTooltip.vue?vue&type=script&lang=ts"
export * from "./PaginationTooltip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports